import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8f54b920")

_pushScopeId("data-v-8f54b920")
const _hoisted_1 = { class: "message-wrapper" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "20"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "nonzero",
    d: "M20 0v1.4c-.6 13.6 1.7 14.7 6.7 18-5.6 0-11.7-2.2-14.2-4-3.5 2.7-8.2 4-12.5 4V0h20z"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: ["wrapper ion-text-wrap", [_ctx.message.attributes.direction]]
  }, [
    _createVNode("div", {
      class: "avatar-wrapper",
      title: _ctx.timestamp
    }, [
      _createVNode("span", {
        class: "avatar-initial",
        textContent: _ctx.initial
      }, null, 8, ["textContent"])
    ], 8, ["title"]),
    _createVNode("div", _hoisted_1, [
      (_ctx.showName)
        ? (_openBlock(), _createBlock("cite", {
            key: 0,
            class: "name",
            textContent: _ctx.name
          }, null, 8, ["textContent"]))
        : _createCommentVNode("", true),
      _createVNode("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.message.attributes.preview) + " ", 1 /* TEXT */),
        _hoisted_3
      ])
    ])
  ], 2))
})